
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 6">
  <path
    d="M4.18714 4.95L7.08214 1.1568C7.24831 0.93905 7.27654 0.645871 7.15496 0.400418C7.03338 0.154965 6.78305 -0.000240027 6.50914 2.78651e-07H0.720036C0.44623 -1.16806e-05 0.196114 0.15528 0.0746839 0.400687C-0.0467465 0.646093 -0.0184727 0.939137 0.147636 1.1568L3.04264 4.95C3.17884 5.12838 3.39045 5.23305 3.61489 5.23305C3.83933 5.23305 4.05093 5.12838 4.18714 4.95Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ArrowRadius',
    }) as DefineComponent
    </script>
    